// extracted by mini-css-extract-plugin
module.exports = {"container":"TagList_container__H7D5N","label":"TagList_label__ZiVPk","list":"TagList_list__TZ_ba"};